import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { NgbModalConfig, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserPipe, CapitalizeWordsPipe, FlagIconPipe } from 'src/app/pipes/format.pipe';
import { BrowserAttestation } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';
import { CommonsModalPartComponent } from '../../commons-modal-part/commons-modal-part';
import { ModalBrowserAttestationsComponent } from './modal-browser-attestations/modal-browser-attestations.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-details-browser-attestations',
    templateUrl: './details-browser-attestations.component.html',
    styleUrls: ['./details-browser-attestations.component.scss'],
    providers: [NgbModalConfig, NgbModal, TranslationService],
    imports: [
      TranslateModule, 
      MatDividerModule,
      FlagIconPipe,
      CapitalizeWordsPipe,
      BrowserPipe,
      CommonModule,
      CommonsModalPartComponent,
      ModalBrowserAttestationsComponent,
      NgbTooltipModule
    ],
    standalone: true
})
export class DetailsBrowserAttestationsComponent{

  @Input() browserAttestation?: BrowserAttestation;
  @Output() appFilter: EventEmitter<string> = new EventEmitter<string>();

  readonly translationService = inject(TranslationService);

  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
   
    config.backdrop='static';
    config.keyboard=false;
  }

  public checkScore(score: number|undefined): string {
    if (score === undefined) {
      return 'undefined';
    }
    if (score < 50) {
      return 'low';
    }
    if (score < 70) {
      return 'medium';
    }
    return 'high';    
  }

  open({content}: { content: any }, size:string, matClass:string): void {
    this.modalService.open(content,{size:size,centered:true, modalDialogClass:matClass});
  }
  

  getMetaData(){
    if(this.browserAttestation?.metadata && Object.entries(this.browserAttestation?.metadata).length>0){
    return new Map(Object.entries(this.browserAttestation.metadata))
    }else{return undefined}
  }

}
